import { memo, useCallback, forwardRef, useEffect, useState } from "react";
import { ChartWidget } from "../Watchlist";
import { BzDropdown, BzToolTip } from "../../components";
import { useSelector, useDispatch } from "react-redux";
import { createChartUrl, getDecryptLocalStorage, sendDataToChartBestFive, setEncryptLocalStorage, validUrl } from "../../utils/global_functions";
import { LOCATIONS, TL_INDEX, LOCAL_STORAGE_KEYS, WATCHLIST_GRID_INDEX } from "../../utils/global_variables";
import { Col, Container, Dropdown, Row } from "react-bootstrap";
import { getMarketMovementFailure, getMarketMovementInfo, getSecurityDetails } from '../../redux/actions/marketOverview';
import CandleChart from "../Analysis/CandleChart";
import { getHistoricChartData } from "../../apis/nontransactional";
import { convertHistoricData } from "../../controllers/analysis";
import moment from "moment";
import LineChart from "../Analysis/LineChart";
import AreaChart from "../Analysis/AreaChart";
import BarChart from "../Analysis/BarChart";
import { useWFHMessages } from "../../hooks";
import { sendTouchlineRequest } from "../../apis/web_socket";
import ZeroStates from "../ZeroStates";
const mappedTime = {
  '1D': 'Intraday',
  '5D': 5,
  '1M': 30,
  '1Y': 260,
  '2Y': 520,
  '5Y': 1300,
  'MAX': 0,
};
const CustomDropdownToggle = forwardRef(({ children, onClick, className }, ref) => (
  <div
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
    className={className}
  >
    {children}
  </div>
));
//Vaibhav Singh : BT-107400 : Added Chart component for scrip overview
const OverviewChart = ({ handleClose, isExpand }) => {
  //Vaibhav Singh : BT-107400 : Added Chart component for scrip overview:16-11-23: Start
  const scripOverviewData = useSelector(state => state.marketOverview.scripOverviewData);
  const chartAttributes = useSelector(state => state.appInfo.chartAttributes);
  const marketMovementInfo = useSelector(state => state.marketOverview.marketMovementInfo);
  const [timeInterval, setTimeInterval] = useState('1D');
  const [chartUrl, setChartUrl] = useState('');
  const [lineData, setLineData] = useState([]);
  const [chartData, setChartData] = useState([]);
  const [chartType, setChartType] = useState('Candles');
  const [maType, setMaType] = useState(20);
  const [apiCalled, setApiCalled] = useState(false);
  const [zeroStateShow, setZeroStateShow] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    setChartUrl(createChartUrl(scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID], scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN], chartAttributes));
  }, [chartAttributes, scripOverviewData]);
  const handleOpen = () => {
    setEncryptLocalStorage("OVERVIEW_CHART_DATA", JSON.stringify({ chartUrl: createChartUrl(scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID], scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN], chartAttributes), data: scripOverviewData }));
    setTimeout(() => {
      window.open(LOCATIONS.CHART);
    }, 300);
  };

  const handleApi = useCallback(async (time) => {
    setLineData([]);
    if (time !== '1D') {
      let temp = await getHistoricChartData({
        MktSegId: scripOverviewData[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID],
        Token: scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN],
        Records: mappedTime[time],
      });
      let data = [];
      temp.data.result.forEach(x => {
        if (x?.length > 0) {
          data.push(...convertHistoricData(x));
        }
      });
      data = data.map(x => {
        return {
          time: moment(x?.ltt)?.format("YYYY-MM-DD"),
          value: x?.close,
          open: x?.open,
          high: x?.high,
          low: x?.low,
          close: x?.close,
          volume: x?.volume
        };
      });
      setLineData(data);
      if (data?.length === 0 && (chartUrl==="" || validUrl(chartUrl) === false)) {
        setZeroStateShow(true)
      } else {
        setZeroStateShow(false)
      }
    }
  }, [scripOverviewData]);

  useEffect(() => {
    setChartData([]);
    sendTouchlineRequest([{ exchangeId: scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID], token: scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN], isSubscribe: true }]);
    if (timeInterval === '1D') {
      let temp = [];
      marketMovementInfo.forEach((x, i) => {
        if (i !== 0 && marketMovementInfo[i - 1]?.Time === x?.Time) { return; }
        let epochTime = moment(x.Time, 'HH:mm:ss').add(5, 'hours').add(30, 'minutes').unix()
        temp.push({
          time: epochTime,
          open: x.nOpen,
          close: x.nClose,
          high: x.nHigh,
          low: x.nLow,
          value: x?.nClose,
          volume: x?.nTotalQtyTraded
        });
      });
      setChartData(temp);
      if (temp?.length === 0 && (chartUrl==="" || validUrl(chartUrl) === false)) {
        setZeroStateShow(true)
      } else {
        setZeroStateShow(false)
      }
    } else {
      setChartData(lineData);
    }
  }, [lineData, marketMovementInfo, timeInterval, scripOverviewData]);

  useEffect(() => {
    if ((!chartUrl || chartUrl === '') && !apiCalled && lineData?.length === 0) {
      handleApi('5D');
      setApiCalled(true);
    }
  }, [apiCalled, chartUrl, handleApi, lineData, scripOverviewData]);

  useEffect(() => {
    setLineData([])
    setApiCalled(false)
  }, [scripOverviewData])

  /* Deepti B. BT-107426 calling get chart data API on click of chart icon */
  useEffect(() => {
    if ((!chartUrl || chartUrl === '')) {
      if (timeInterval === '1D') {
        if (scripOverviewData?.length !== 0) {
          const objMarketMovementPaylod = {
            MktSegId: scripOverviewData[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID],
            Token: scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN],
            TimeInterval: 1
          };
          const decimalLocator = scripOverviewData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR];
          const decimalLocatorLength = scripOverviewData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH];
          dispatch(getMarketMovementInfo(objMarketMovementPaylod, decimalLocator, decimalLocatorLength));
          dispatch(getSecurityDetails({ mktSegmentId: scripOverviewData[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID], token: scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN] }));
        } else { }
      }
    }
  }, [chartUrl, dispatch, scripOverviewData, timeInterval]);

  useEffect(() => {
    let interval = setInterval(() => {
      if ((!chartUrl || chartUrl === '')) {
        if (timeInterval === '1D') {
          if (scripOverviewData?.length !== 0) {
            const decimalLocator = scripOverviewData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR];
            const decimalLocatorLength = scripOverviewData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH];
            let objMarketMovementPaylod = {
              MktSegId: scripOverviewData[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID],
              Token: scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN],
              TimeInterval: 1
            };
            dispatch(getMarketMovementFailure([]));
            dispatch(getMarketMovementInfo(objMarketMovementPaylod, decimalLocator, decimalLocatorLength));
            objMarketMovementPaylod = {};
          } else { }
        }
      }
    }, 60000);
    return () => {
      clearInterval(interval);
    };
  }, [chartUrl, dispatch, scripOverviewData, timeInterval]);

  useWFHMessages('bestfive', (e) => {
    if (scripOverviewData?.length) {
      if (e.detail[TL_INDEX.TOKEN] === scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN]) {
        sendDataToChartBestFive(e.detail, scripOverviewData);
      }
    }
  });

  //Vaibhav Singh: 14-03-24: Issue fixed with CHart toggle: Start
  const [toggledURL, setToggledURL] = useState('');
  useEffect(() => {
    if (chartAttributes?.nMultiChartPresent) {
      const chartId = JSON?.parse(getDecryptLocalStorage(LOCAL_STORAGE_KEYS.PREFFERED_CHART));
      if (chartId) {
        setToggledURL(chartId?.name);
      }
    }
  }, [chartAttributes]);
  //Vaibhav Singh: 18-03-23: Added new call up function:start
  const handleChangeChart = (each, chartAttributes) => {
    setToggledURL(each?.name);
    setChartUrl(createChartUrl(scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID], scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN], chartAttributes, "", each));
  };
  //Vaibhav Singh : BT-107400 : Added Chart component for scrip overview: 16-11-23: End
  
  
  return (
    <>
      <Container fluid className='p-0'>
        {(chartAttributes?.nChartUrl === "" || chartAttributes?.nChartUrl === undefined) ? <div className='fixed-icons-wrapper'>
          <div className='d-flex justify-content-end align-items-center'>
            <div className='background-icon' onClick={handleClose}>
              <BzToolTip placement={isExpand ? 'left' : 'top'} TooltipMsg={'Collapse'}><div className={`icon-16 icon-dark icon-collapse`}></div></BzToolTip>
            </div>
          </div>
        </div> : null}
        <Row className='g-0 pb-2'>
          <Col className='d-flex justify-content-start align-items-center'>
            {/* {(chartAttributes?.nChartUrl === "" || chartAttributes?.nChartUrl === undefined) ? null : <div className='icon-backward-arrow icon-dark icon-16' onClick={handleClose}></div>}
            {(chartAttributes?.nMultiChartPresent) ?
              <div className='screen-dropdown ms-3'>
                <BzDropdown>
                  <Dropdown.Toggle className='d-flex align-items-center'>
                    <span className='icon-trading-view icon-20 me-1'></span>
                    <span>{toggledURL}</span>
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {chartAttributes?.nChartUrl?.map((each) => {
                      return <Dropdown.Item onClick={() => { handleChangeChart(each, chartAttributes); }}>{each?.name}</Dropdown.Item>;
                    })}
                  </Dropdown.Menu>
                </BzDropdown>
              </div> : chartAttributes?.nChartUrl ? null : */}
                <>
                  <Container fluid className='p-0'>
                    <Row className='g-0 bdr-top bdr-btm py-2'>
                      <Col md={6} className='d-flex justify-content-start align-items-center'>
                        {/* <div className='me-3 ps-3'>
                          <Dropdown className='d-flex align-items-center'>
                            <Dropdown.Toggle as={CustomDropdownToggle} className='d-flex align-items-center'>
                              <div className={`icon-16 icon-${chartTab.toLowerCase()} icon-dark me-1`}></div>
                              <div className='font-medium font-size1 pe-2'>{chartTab}</div>
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item onClick={(e) => { setChartTab('Intraday') }}>
                                <div className='d-flex justify-content-start align-items-center'>
                                  <div className='icon-16 icon-intraday icon-dark me-2'></div>
                                  <div className='p-t-3'>Intraday</div>
                                </div>
                              </Dropdown.Item>
                              <Dropdown.Item onClick={(e) => { setChartTab('Historical') }}>
                                <div className='d-flex justify-content-start align-items-center'>
                                  <div className='icon-16 icon-historical icon-dark me-2'></div>
                                  <div className='p-t-3'>Historical</div>
                                </div>
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div> */}
                        {/* {chartTab === 'Intraday' ? null : */}
                        <div className='me-3 ps-3 bdr-lft'>
                          <Dropdown className='d-flex align-items-center'>
                            <Dropdown.Toggle as={CustomDropdownToggle} className={`d-flex align-items-center`}>
                              <div className='font-medium font-size1 pe-2'>{timeInterval} ({timeInterval === '1D' ? '1 Min' : 'Daily'})</div>
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              {Object.keys(mappedTime)?.map((each) => {
                              return <Dropdown.Item onClick={(e) => { handleApi(each); setTimeInterval(each); }}>{each} ({each === '1D' ? '1 Min' : 'Daily'})</Dropdown.Item>;
                              })}
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                        {/* } */}
                        <div className='me-3 ps-3 bdr-lft'>
                          <Dropdown className='d-flex align-items-center'>
                            <Dropdown.Toggle as={CustomDropdownToggle} className='d-flex align-items-center'>
                              <div className='icon-16 icon-function icon-dark me-1'></div>
                              <div className='font-medium font-size1 pe-2'>SMA {maType}</div>
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item onClick={() => { setMaType(20); }}>SMA 20</Dropdown.Item>
                              <Dropdown.Item onClick={() => { setMaType(50); }}>SMA 50</Dropdown.Item>
                              <Dropdown.Item onClick={() => { setMaType(100); }}>SMA 100</Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                        <div className='me-3 ps-3 bdr-lft'>
                          <Dropdown className='d-flex align-items-center'>
                            <Dropdown.Toggle as={CustomDropdownToggle} className='d-flex align-items-center'>
                              <div className={`icon-16 icon-${chartType.toLowerCase()} icon-dark me-1`}></div>
                              <div className='font-medium font-size1 pe-2'>{chartType}</div>
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item onClick={() => { setChartType('Candles'); }}>
                                <div className='d-flex justify-content-start align-items-center'>
                                  <div className='icon-16 icon-candles icon-dark me-2'></div>
                                  <div className='p-t-3'>Candles</div>
                                </div>
                              </Dropdown.Item>
                              <Dropdown.Item onClick={() => { setChartType('Line'); }}>
                                <div className='d-flex justify-content-start align-items-center'>
                                  <div className='icon-16 icon-line icon-dark me-2'></div>
                                  <div className='p-t-3'>Line</div>
                                </div>
                              </Dropdown.Item>
                              <Dropdown.Item onClick={() => { setChartType('Bars'); }}>
                                <div className='d-flex justify-content-start align-items-center'>
                                  <div className='icon-16 icon-bars icon-dark me-2'></div>
                                  <div className='p-t-3'>Bars</div>
                                </div>
                              </Dropdown.Item>
                              <Dropdown.Item onClick={() => { setChartType('Area'); }}>
                                <div className='d-flex justify-content-start align-items-center'>
                                  <div className='icon-16 icon-area icon-dark me-2'></div>
                                  <div className='p-t-3'>Area</div>
                                </div>
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                      </Col>
                      <Col md={6} className="d-flex justify-content-end align-items-center">
                      {(chartAttributes?.nChartUrl === "" || chartAttributes?.nChartUrl === undefined) ? null : <BzToolTip placement={'top'} TooltipMsg={'Open in new tab'}><div className='icon-16 icon-expand-fullview icon-dark ms-3' onClick={handleOpen}></div></BzToolTip >}
                      {(chartAttributes?.nChartUrl === "" || chartAttributes?.nChartUrl === undefined) ? null : <BzToolTip placement={'top'} TooltipMsg={'Back to Overview'}><div className='icon-16 icon-dark icon-close ms-3' onClick={handleClose}></div></BzToolTip>}
                      </Col>
                    </Row>
                  </Container>
                </>            
          </Col>
          
        </Row>
        {!zeroStateShow ?
          chartUrl ? <ChartWidget chartUrl={chartUrl} /> : chartType == 'Candles' ? <CandleChart style={{ height: "500px" }} lineData={chartData} isMa={maType} isExpand={isExpand} /> : chartType == 'Line' ? <LineChart style={{ height: "500px" }} lineData={chartData} isMa={maType} isExpand={isExpand} /> : chartType == 'Bars' ? <BarChart style={{ height: "500px" }} lineData={chartData} isMa={maType} isExpand={isExpand} /> : <AreaChart style={{ height: '500px' }} lineData={chartData} isMa={maType} isExpand={isExpand} />
          : <Row className='g-0'>
            <Col md={6} className='mrgauto'>
              <div className='zero-state-alerts zero-state-alerts-lg'>
                <ZeroStates subText="" isButtonShowing={false} icon='icon-64 icon-missed-something mb-3 mrgauto' />
                <div className='font-regular font-size2 color-nodata'>Something went wrong.</div>
                <div className='font-regular font-size2 color-nodata'>Let us fix the problem and get back to you soon. Meanwhile try</div>
                <div className='font-regular font-size2 color-nodata'><span className='color-primary'>Refreshing the page</span> or come back later.</div>
              </div>
            </Col>
          </Row>}
      </Container>


    </>
  );
};
export default memo(OverviewChart);